import "./welcome.css"

function Welcome(){
    return (<div className="welcome">
        <br></br>
        <h1>Hi</h1>

        <div className="typewriter ">
        <h1>Welcome to the EMOJI </h1>
        <h1>guess game</h1>
        </div>
    </div>)

}

export default Welcome;